import { useState, useEffect } from 'react';
import { formatCountdown } from '@/lib/utils';

interface CountdownResult {
  totalSeconds: number;
  formatted: string;
}

export function useCountdown(targetTime: Date | null): CountdownResult {
  const [totalSeconds, setTotalSeconds] = useState(0);

  useEffect(() => {
    if (!targetTime) {
      setTotalSeconds(0);
      return;
    }

    const tick = () => {
      const secs = Math.max(0, Math.round((targetTime.getTime() - Date.now()) / 1000));
      setTotalSeconds(secs);
    };

    tick(); // run immediately
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetTime]);

  return {
    totalSeconds,
    formatted: targetTime ? formatCountdown(totalSeconds) : '',
  };
}
